import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  fetchTopCities: ['filter'],
  fetchTopCitiesLoading: null,
  fetchTopCitiesSuccess: ['data'],
  fetchTopCitiesFail: ['error'],

  fetchPeakHour: ['filter'],
  fetchPeakHourLoading: null,
  fetchPeakHourSuccess: ['data'],
  fetchPeakHourFail: ['error'],

  fetchAverageDuration: ['filter'],
  fetchAverageDurationLoading: null,
  fetchAverageDurationSuccess: ['data'],
  fetchAverageDurationFail: ['error'],

  fetchTopVouchers: ['filter'],
  fetchTopVouchersLoading: null,
  fetchTopVouchersSuccess: ['data'],
  fetchTopVouchersFail: ['error'],

  fetchTopSites: ['filter'],
  fetchTopSitesLoading: null,
  fetchTopSitesSuccess: ['data'],
  fetchTopSitesFail: ['error'],

  fetchOverview: ['filter'],
  fetchOverviewLoading: null,
  fetchOverviewSuccess: ['data'],
  fetchOverviewFail: ['error'],

  fetchTransactionsStatistics: ['filter'],
  fetchTransactionsStatisticsLoading: null,
  fetchTransactionsStatisticsSuccess: ['data'],
  fetchTransactionsStatisticsFail: ['error'],

  fetchUserSignup: ['filter'],
  fetchUserSignupLoading: null,
  fetchUserSignupSuccess: ['data'],
  fetchUserSignupFail: ['error'],

  fetchTopUsers: ['filter'],
  fetchTopUsersLoading: null,
  fetchTopUsersSuccess: ['data'],
  fetchTopUsersFail: ['error'],

  fetchUsersActivity: ['filter'],
  fetchUsersActivityLoading: null,
  fetchUsersActivitySuccess: ['data'],
  fetchUsersActivityFail: ['error'],

  fetchUsersStatistics: ['filter'],
  fetchUsersStatisticsLoading: null,
  fetchUsersStatisticsSuccess: ['data'],
  fetchUsersStatisticsFail: ['error'],

  fetchEnergyChart: ['filter'],
  fetchEnergyChartLoading: null,
  fetchEnergyChartSuccess: ['data'],
  fetchEnergyChartFail: ['error'],

  fetchTimeForFirstCharge: ['filter'],
  fetchTimeForFirstChargeLoading: null,
  fetchTimeForFirstChargeSuccess: ['data'],
  fetchTimeForFirstChargeFail: ['error'],

  fetchTimeBetweenTrans: ['filter'],
  fetchTimeBetweenTransLoading: null,
  fetchTimeBetweenTransSuccess: ['data'],
  fetchTimeBetweenTransFail: ['error'],

  fetchPaymentBreakdown: ['filter'],
  fetchPaymentBreakdownLoading: null,
  fetchPaymentBreakdownSuccess: ['data'],
  fetchPaymentBreakdownFail: ['error'],
})
export const AnalyticsTypes = Types
export default Creators
